export const shadow = {
  mildShadow: '0 2px 15px rgba(68, 68, 79, 0.08)',
};
